/* eslint-disable @next/next/no-img-element */

import React, { useMemo } from "react";
import Head from "next/head";

import Backend from "../../../utils/Backend";
import categories from "../../../helper/categories";
import handleTimeout from "../../../helper/timeout_handler";
import { formatDate } from "../../../helper/date_formatter";

import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import RichText from "../../../components/RichText";

import KeepBrowsingVehicles from "../../../components/KeepBrowsingVehicles";
import Tags from "../../../components/Tags";

import GoogleAd from "../../../components/GoogleAd";
import { googleAdIds, links } from "../../../helper/constants";
import { useIsBoiWebsite } from "../../../components/Context/WebsiteType";
import { ITag } from "../../../interfaces/ITag";
import { parseArticleTags } from "../../../helper/functions/parseArticleTags";

export default function PostPage({ post }: any) {
	const isBoiWebsite = useIsBoiWebsite();

	const hiddenTags = useMemo(() => {
		let tags = "";
		post?.tags?.split(",").forEach((tag: ITag) => {
			if (!tag.visible) {
				tags += `${tag.name}, `;
			}
		});

		if (tags.length) tags = tags.slice(0, -2);

		return tags;
	}, [post]);

	const renderPost = () => {
		if (post)
			return (
				<div className="post-holder learn-post-holder">
					<h1 className="post-title">{post.title}</h1>

					<p className="post-meta">
						By {post.author} • {formatDate(post.created_at)}
					</p>

					<Tags tags={Array.isArray(post.tags) ? post.tags : parseArticleTags(post.tags)} base_url={links.videos} className="post-tags" link isBoiWebsite={isBoiWebsite} isArticle={true} />

					<div className="preview-image">
						<img src={post.featured_image} alt={post.image_alt} />
					</div>

					<RichText content={post.content} />
				</div>
			);
	};

	return (
		<>
			{post && (
				<Head>
					<title>
						{post.title} - {categories.articles} | Nevo
					</title>
					<meta name="author" content={post.author || "Nevo"} />
					<meta name="description" content={post.page_metadata} />
					<meta name="keywords" content={hiddenTags} />
				</Head>
			)}

			<Header transparent={isBoiWebsite} />

			<div className="page-holder post-page-holder">
				{!isBoiWebsite && <GoogleAd adId={googleAdIds.horizontal_banner} className="ad-banner-post" articlePage />}

				{renderPost()}
			</div>

			<KeepBrowsingVehicles />

			<Footer />
		</>
	);
}

export async function getServerSideProps({ res, params: { slug } }: any) {
	// params contains the vehicle `id`
	res.setHeader("Cache-Control", "public, s-maxage=10, stale-while-revalidate=59");

	const response = await handleTimeout(Backend.getPostBySlug(slug), `Post ${slug}`);

	if (!response) {
		throw new Error("Failed to fetch Post");
	}

	const post = response.data.content;

	// Pass data to the page via props
	return {
		props: { post }
	};
}
